import './ImagePlaceholder.css'

const ImagePlaceholder = ({ image, title, subtitle }) => {
  return (<div className='image-placeholder-component'>
    {image && <img src={image} />}
    {title && <b>{title}</b>}
    {subtitle && <p>
      {subtitle}
    </p>}
  </div>)
}

export default ImagePlaceholder;